// Talks to the local companion service running on the accountant's own PC
// (see the feasibility doc / tally-sync-demo prototype) -- deliberately NOT
// using the `http` axios instance, since that's wired for ATOM's own API
// (auth headers, global loading state, error interceptors) and this is a
// different origin entirely.

const COMPANION_BASE = "http://127.0.0.1:8765";
export const TOKEN_STORAGE_KEY = "atom_tally_bridge_token";

export const getStoredBridgeToken = () => localStorage.getItem(TOKEN_STORAGE_KEY) || "";
export const setStoredBridgeToken = (token: string) => localStorage.setItem(TOKEN_STORAGE_KEY, token);

export async function getCompanionStatus() {
  const res = await fetch(`${COMPANION_BASE}/api/status`);
  if (!res.ok) throw new Error("bridge_status_failed");
  return res.json();
}

export async function getOpenCompanies(token: string) {
  const res = await fetch(`${COMPANION_BASE}/api/open-companies`, {
    headers: { "X-Bridge-Token": token },
  });
  if (res.status === 401) throw new Error("bridge_unauthorized");
  return res.json();
}

export async function pushInvoicesToTally(
  token: string,
  companyName: string,
  invoices: any[]
) {
  const res = await fetch(`${COMPANION_BASE}/api/push`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-Bridge-Token": token },
    body: JSON.stringify({ companyName, invoices }),
  });
  if (res.status === 401) {
    throw new Error("bridge_unauthorized");
  }
  return res.json();
}
